// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../subWeeks/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var subWeeks = convertToFP(fn, 2);
export default subWeeks;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/subWeeks/index.js
// module id = 1010
// module chunks = 0